import {Image} from "../../data/models/image";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ImageHandler {

  public addAltText(image: Image, altText: string): Image {
    if (image) {
      image.altText = altText;
    }

    return image;
  }
}
